
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { StagingCreateEnvironment } from "@/services/WebsiteStaging/interfaces";
import CreateStagingForm from "@/services/WebsiteStaging/forms/createStagingForm";
import { WPXFormValue } from "@/components/templates/WPXForm";
import { CreateUserForm } from "@/services/Database/forms/CreateUserForm";

@Component({
  mixins: [Themeable],
})
export default class StagingDialog extends Vue {
  @Prop() public domain: string;

  public form: WPXFormValue<CreateStagingForm> = new WPXFormValue(CreateStagingForm);
  public visible: boolean = false;


  public stagingEnvironments: { text: string, value: string }[] = [
    { text: 'Clone', value: 'clone' },
    { text: 'New', value: 'new' },
    { text: 'Empty', value: 'empty' },
  ];

  public get message(): string {
    return `${this.domain}`;
  }

  public async created(): Promise<void> {
    this.visible = true;
  }

  public create(): void {
    const env: StagingCreateEnvironment = {
      type: this.form.data.selectedEnvironment,
    };

    if (this.form.data.selectedEnvironment === 'new') {
      env.wpEmail = this.form.data.wpEmail;
      env.wpUsername = this.form.data.wpUsername;
      env.wpPassword = this.form.data.wpPassword;
    }

    console.log(env);
    this.$emit('createStaging', env);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
